import { useUserStore } from '@/store/modules/user/store.js';
import SupportModal from '@/components/modals/Support.vue';

export default {
    components: {
        SupportModal,
    },

    data() {
        return {
            supportModalOpened: false,
        };
    },

    computed: {
        authUser() {
            return useUserStore().authUser;
        },
    },

    methods: {
        getSupportUrl() {
            return process.env.VUE_APP_SUPPORT_URL;
        },

        openSupport(inNewTab = true) {
            if (this.authUser.content_language !== 'en') {
                this.supportModalOpened = true;

                return;
            }

            if (inNewTab) {
                window.open(this.getSupportUrl(), '_blank');
            } else {
                window.location.replace(this.getSupportUrl());
            }
        },
    },
};
